import React from "react";
import Card from "../Card/Card";
import "./Cards.css";

import networking from "../../assets/networking.jpg";
import workshops from "../../assets/workshops.jpg";
import support from "../../assets/support.jpg";
import online from "../../assets/Online.jpg";

const Cards = () => {
  return (
    <div className="cards-container">
      <div id="features" className="title-align">
        <h1 style={{fontSize: "2.25em"}} className="title-margin-removal">Features</h1>
      </div>
      <div className="cards-layout">
        <Card image={networking} content="Networking" text="Connect and engage with dreamers of various interests"/>
        <Card image={workshops} content="Workshops" text="Evolve your talents through different workshop and also organise one"/>
        <Card image={support} content="Support" text="Get recognised mentored and also collaborate with talents of distinctive interests"/>
        <Card image={online} content="Online" text="The new digital stage for India"/>
      </div>
    </div>
  );
};

export default Cards;
